import { Link } from 'react-router-dom';

interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
  count: number;
  imageUrl: string;
  isFeatured: boolean;
}

const categories: Category[] = [
  {
    slug: 'romance',
    name: '浪漫爱情',
    icon: 'ri-heart-line',
    description: '甜蜜恋爱、青春校园',
    count: 1280,
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20illustration%20with%20soft%20pink%20and%20warm%20peach%20tones%2C%20elegant%20couple%20silhouette%20art%2C%20dreamy%20atmosphere%2C%20minimalist%20composition%2C%20delicate%20line%20art%20style%2C%20clean%20background%20with%20subtle%20gradient%2C%20editorial%20quality&width=600&height=400&seq=cat-romance&orientation=landscape',
    isFeatured: true,
  },
  {
    slug: 'action',
    name: '热血动作',
    icon: 'ri-fire-line',
    description: '格斗竞技、超能激战',
    count: 945,
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20action%20manhwa%20illustration%20with%20dynamic%20energy%20and%20warm%20red%20orange%20tones%2C%20dramatic%20movement%20lines%2C%20stylized%20fight%20scene%20aesthetic%2C%20powerful%20composition%2C%20clean%20modern%20webtoon%20style%2C%20cinematic%20lighting%2C%20minimal%20background&width=500&height=300&seq=cat-action&orientation=landscape',
    isFeatured: false,
  },
  {
    slug: 'fantasy',
    name: '奇幻异界',
    icon: 'ri-magic-line',
    description: '异世界、魔法冒险',
    count: 856,
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20illustration%20with%20magical%20atmosphere%20and%20warm%20golden%20amber%20tones%2C%20mystical%20landscape%2C%20stylized%20magic%20elements%2C%20ethereal%20composition%2C%20clean%20modern%20webtoon%20style%2C%20soft%20glowing%20effects%2C%20editorial%20quality&width=500&height=300&seq=cat-fantasy&orientation=landscape',
    isFeatured: false,
  },
  {
    slug: 'thriller',
    name: '悬疑惊悚',
    icon: 'ri-ghost-line',
    description: '推理探案、心理悬疑',
    count: 523,
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20manhwa%20illustration%20with%20mysterious%20atmosphere%20and%20dark%20warm%20sepia%20tones%2C%20suspenseful%20composition%2C%20stylized%20noir%20aesthetic%2C%20dramatic%20shadows%2C%20clean%20modern%20webtoon%20style%2C%20cinematic%20lighting%2C%20minimal%20design&width=500&height=300&seq=cat-thriller&orientation=landscape',
    isFeatured: false,
  },
];

const totalCount = categories.reduce((sum, c) => sum + c.count, 0);

export default function CategorySection() {
  return (
    <section className="relative bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10 md:mb-14">
            <div>
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
                探索无限分类
              </h2>
              <p className="text-lg md:text-xl font-heading text-foreground-800 mt-1">
                发现你的下一部作品
              </p>
            </div>
            <p className="text-sm text-foreground-500 max-w-md">
              覆盖浪漫爱情、热血动作、奇幻异界、悬疑惊悚等多种类型，{totalCount}+ 部精选漫画等您探索
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {categories.map((cat, idx) => {
              const isFirst = idx === 0;
              return (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`group relative overflow-hidden rounded-lg bg-background-100 hover:bg-background-200/70 transition-all duration-300 ${
                    isFirst ? 'lg:row-span-2 lg:col-span-1' : ''
                  }`}
                >
                  {isFirst ? (
                    <div className="flex flex-col h-full min-h-[380px]">
                      <div className="relative h-56 overflow-hidden">
                        <img
                          src={cat.imageUrl}
                          alt={`韩漫${cat.name}分类`}
                          title={`韩漫在线观看 - ${cat.name}`}
                          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-background-100 via-transparent to-transparent"></div>
                      </div>
                      <div className="flex-1 p-5 flex flex-col justify-end">
                        <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-3">
                          <i className={`${cat.icon} text-lg`}></i>
                        </div>
                        <h3 className="text-lg font-heading font-bold text-foreground-950 mb-1">
                          {cat.name}
                        </h3>
                        <p className="text-sm text-foreground-500 mb-2">{cat.description}</p>
                        <span className="text-xs text-foreground-400">{cat.count.toLocaleString()} 部作品</span>
                      </div>
                    </div>
                  ) : (
                    <div className="flex flex-col h-full min-h-[180px] p-5">
                      <div className="flex items-center gap-3 mb-3">
                        <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                          <i className={`${cat.icon} text-lg`}></i>
                        </div>
                        <h3 className="text-base font-heading font-bold text-foreground-950">
                          {cat.name}
                        </h3>
                      </div>
                      <p className="text-sm text-foreground-500 mb-2">{cat.description}</p>
                      <span className="text-xs text-foreground-400 mt-auto">{cat.count.toLocaleString()} 部作品</span>
                      <div className="mt-4 h-28 overflow-hidden rounded-lg">
                        <img
                          src={cat.imageUrl}
                          alt={`韩漫${cat.name}分类`}
                          title={`免费韩国漫画 - ${cat.name}`}
                          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                        />
                      </div>
                    </div>
                  )}
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}